<template>
  <div class="relative">
    <div class="aspect-ratio-5/6 lg:hidden" />
    <div class="hidden aspect-ratio-16/9 lg:block" />

    <GmapMap
      ref="gmap"
      :options="options"
      class="js-map"
      :center="center"
      :zoom="7"
      @click="closeEstate"
    >
      <GmapCluster
        v-if="markerCluster"
        :zoom-on-click="true"
        :styles="clusterStyle"
      >
        <gmap-marker
          v-for="(m, index) in markerLocations"
          ref="marker"
          :key="index"
          :position="m.position"
          :icon="m.icon"
          @click="openEstate(m)"
        />
      </GmapCluster>

      <gmap-info-window
        v-if="infoWinOpen"
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="closeEstate"
      >
        <a
          v-if="infoWindowData.location"
          :href="formatLink(infoWindowData.permalink)"
          target="_blank"
          class="block max-w-xs"
        >
          <div class="relative">
            <p
              v-if="
                infoWindowData.status === 'sold' ||
                  infoWindowData.status === 'option' ||
                  infoWindowData.status === 'under_contract'
              "
              class="absolute top-0 right-0 z-10 px-2 py-1 m-2 text-sm tracking-wider text-white uppercase rounded-md bg-danger-500"
            >
              <template v-if="infoWindowData.status === 'sold'">Verkocht</template>
              <template v-if="infoWindowData.status === 'under_contract'">
                Onder contract
              </template>
              <template v-if="infoWindowData.status === 'option'">
                In optie
              </template>
            </p>
            <div class="aspect-ratio-16/9" />
            <img
              :src="infoWindowData.image"
              class="absolute top-0 left-0 object-cover object-center w-full h-full "
            >
          </div>
          <div class="p-5 text-white bg-brand-500">
            <p class="text-lg font-medium">
              {{ infoWindowData.title[lang] }}
            </p>
            <div
              v-if="infoWindowData.status === 'available'"
              class="mt-1"
            >
              <p class="mb-1 opacity-80">
                {{ infoWindowData.location.street }},
                {{ infoWindowData.location.postal_code }}
                {{ infoWindowData.location.city }}
              </p>
              <p>
                &euro;
                {{ $formatNumber(parseInt(infoWindowData.price), "DOT") }}
              </p>
            </div>
          </div>
        </a>
      </gmap-info-window>
    </GmapMap>
  </div>
</template>

<script>
/* global google */
const slugify = require("slugify");

export default {
  components: {},
  props: ["markerData", "store", "lang", "type"],
  data() {
    return {
      markerLocations: [],
      markerActive: require("../svg/marker-active.svg"),
      markerInactive: require("../svg/marker-inactive.svg"),
      markerCluster: true,
      infoWinOpen: true,
      infoWindowPos: null,
      infoWindowData: {},
      infoOptions: {
        pixelOffset: new google.maps.Size(0, -55),
      },
      clusterStyle: [
        {
          textColor: "white",
          url: require("../svg/cluster.svg"),
          height: 30,
          width: 30,
          textSize: 14,
          fontFamily: "futura-pt, Helvetica, Arial, sans-serif",
          fontWeight: "500",
        },
      ],
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#e9e9e9", }, { lightness: 17, }],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5", }, { lightness: 20, }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [{ color: "#ffffff", }, { lightness: 17, }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ffffff", }, { lightness: 29, }, { weight: 0.2, }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#ffffff", }, { lightness: 18, }],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{ color: "#ffffff", }, { lightness: 16, }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5", }, { lightness: 21, }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#dedede", }, { lightness: 21, }],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              { visibility: "on", },
              { color: "#ffffff", },
              { lightness: 16, },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              { saturation: 36, },
              { color: "#333333", },
              { lightness: 40, },
            ],
          },
          { elementType: "labels.icon", stylers: [{ visibility: "off", }], },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#f2f2f2", }, { lightness: 19, }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ color: "#fefefe", }, { lightness: 20, }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#fefefe", }, { lightness: 17, }, { weight: 1.2, }],
          },
        ],
      },
      center: {
        lat: 50.2000285,
        lng: 4.9881758,
      },
    };
  },
  watch: {
    markerData() {
      this.renderMarkers();
    },
  },
  mounted() {
    this.renderMarkers();
  },
  methods: {
    formatLink(link) {
      const title = slugify(this.infoWindowData.title[this.lang], {
        lower: true,
        strict: true,
      });
      const url = link.split("/");
      let prefix = "";
      if (this.lang === "nl") {
        prefix = "te-huur";
        if (this.type === "sale") {
          prefix = "te-koop";
        }
      } else if (this.lang === "fr") {
        prefix = "a-louer";
        if (this.type === "sale") {
          prefix = "a-vendre";
        }
      }
      const str = `/${this.lang}/${prefix}/${url[5]}/${title}`;
      return str;
    },
    openEstate(marker) {
      this.infoWinOpen = true;
      this.infoWindowPos = {
        lat: Number(marker.position.lat),
        lng: Number(marker.position.lng),
      };
      this.infoWindowData = marker.data;
      this.setMarkerIcon(marker);
    },
    closeEstate() {
      this.infoWinOpen = false;
      this.resetMarkers();
    },
    resetMarkers() {
      this.markerLocations.forEach((marker) => {
        marker.icon = this.markerInactive;
      });
    },
    setMarkerIcon(marker) {
      this.resetMarkers();
      marker.icon = this.markerActive;
    },
    resetMap() {
      this.infoWinOpen = false;
      if (this.markerData.length === 0) {
        this.$refs.gmap.$mapPromise.then(() => {
          this.$refs.gmap.$mapObject.setCenter({
            lat: this.center.lat,
            lng: this.center.lng,
          });
          this.$refs.gmap.$mapObject.setZoom(7);
        });
      } else {
        this.markerCluster = false;
        this.$nextTick(() => {
          this.markerCluster = true;
        });
      }
    },
    centerMap() {
      this.$refs.gmap.$mapPromise.then(() => {
        const bounds = new google.maps.LatLngBounds();
        for (const m of this.markerLocations) {
          bounds.extend(m.position);
        }
        this.$refs.gmap.$mapObject.fitBounds(bounds);
      });
    },
    drawMarkers() {
      this.markerLocations = [];
      this.markerData.forEach((marker) => {
        this.markerLocations.push({
          position: {
            lat: Number(marker.location.latitude),
            lng: Number(marker.location.longitude),
          },
          icon: this.markerInactive,
          data: marker,
        });
      });
    },
    renderMarkers() {
      this.drawMarkers();
      if (this.markerData.length > 0) {
        this.centerMap();
      }
      this.resetMap();
    },
  },
};
</script>

<style>
.vue-map-container {
  @apply absolute top-0 left-0 w-full h-full !important;
}

.gm-style .gm-style-iw-d {
  @apply overflow-hidden rounded-md !important;
}

.gm-style .gm-style-iw-c {
  @apply font-body p-0 bg-transparent rounded-none shadow-none text-base;
}

.gm-style .gm-style-iw-c button {
  @apply hidden !important;
}

.gm-style .gm-style-iw-t::after {
  margin-top: -2px !important;
  background: theme("colors.brand.500");
  @apply shadow-none !important;
}

.fade-enter-active,
.fade-leave-active {
  @apply transition-all duration-200;
}

.fade-enter,
.fade-leave-to {
  @apply opacity-0 transform translate-y-1;
}
</style>
